import { IStore } from 'store/configureStore';

export const selectAttachmentsState = (state: IStore) => state.attachments;
export const selectAttachmentObjectUrlByIds = (store: IStore) =>
    selectAttachmentsState(store).attachmentObjectUrlById;
export const selectAttachmentObjectUrlById = (id: string) => (store: IStore) =>
    selectAttachmentObjectUrlByIds(store)[id]?.objectUrl || null;
